import React from "react";
import { Link } from "react-router-dom";
import { formatShortDate } from "helper/date";

interface DetailLibrary {
  routePath?: string;
}

interface DetailItem {
  publication_start?: string;
}

interface DocumentLibraryDetailSidebarProps {
  t: (key: string) => string;
  item?: DetailItem | null;
  kindLabel?: string;
  fileName?: string;
  title: string;
  previewUrl?: string | null;
  originalUrl?: string | null;
  downloadUrl?: string | null;
  library: DetailLibrary;
  language?: string;
}

export default function DocumentLibraryDetailSidebar({
  t,
  item,
  kindLabel,
  fileName,
  previewUrl: _previewUrl,
  originalUrl,
  downloadUrl,
  library,
  language,
}: DocumentLibraryDetailSidebarProps) {
  return (
    <aside className="DocumentLibraryDetailSidebar">
      <section className="DocumentLibraryDetailPanel DocumentLibraryDetailPanel--meta">
        <p className="DocumentLibraryDetailPanel-kicker">
          {t("document_library.detail.information_kicker")}
        </p>
        <h2 className="DocumentLibraryDetailPanel-title">
          {t("document_library.detail.information_title")}
        </h2>
        <dl className="DocumentLibraryDetailMetaList">
          {item && item.publication_start ? (
            <div className="DocumentLibraryDetailMetaList-item">
              <dt>{t("document_library.detail.publication_start")}</dt>
              <dd>{formatShortDate(item.publication_start, language)}</dd>
            </div>
          ) : null}
          {kindLabel ? (
            <div className="DocumentLibraryDetailMetaList-item">
              <dt>{t("document_library.detail.type")}</dt>
              <dd>{kindLabel}</dd>
            </div>
          ) : null}
          {fileName ? (
            <div className="DocumentLibraryDetailMetaList-item">
              <dt>{t("document_library.detail.file_name")}</dt>
              <dd className="DocumentLibraryDetailMetaList-fileName">{fileName}</dd>
            </div>
          ) : null}
        </dl>
      </section>
      <section className="DocumentLibraryDetailPanel DocumentLibraryDetailPanel--actions">
        <p className="DocumentLibraryDetailPanel-kicker">
          {t("document_library.detail.actions_kicker")}
        </p>
        <h2 className="DocumentLibraryDetailPanel-title">
          {t("document_library.detail.actions_title")}
        </h2>
        <div className="DocumentLibraryDetailActions">
          <Link
            to={library.routePath || "#"}
            className="Button DocumentLibraryDetailActions-secondary"
          >
            {t("common.button_back_list")}
          </Link>
          {originalUrl ? (
            <a
              href={originalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="Button DocumentLibraryDetailActions-secondary"
            >
              {t("document_library.detail.open_document")}
            </a>
          ) : null}
          {downloadUrl ? (
            <a href={downloadUrl} className="Button">
              {t("common.button_downlaod")}
            </a>
          ) : null}
        </div>
      </section>
    </aside>
  );
}
